import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, requestPermission } from 'firebase/messaging';

(() => {
    const subscribeButton = document.querySelector('#subscribe-news')
    if (subscribeButton) {

        const API = subscribeButton.dataset.api
        // const SECTION_ID = subscribeButton.dataset.sectionId
        const csrfToken = document.querySelector('[name="csrf-token"]').content

        const firebaseConfig = {
            apiKey: "AIzaSyAOEYnRx7yzqbRLmUPuJfcROGnxxr_PgE0",
            authDomain: "vsn-ua.firebaseapp.com",
            databaseURL: "https://vsn-ua.firebaseapp.com",
            projectId: "vsn-ua",
            storageBucket: "vsn-ua.appspot.com",
            messagingSenderId: "1051876647954",
            appId: "1:1051876647954:web:e31d5ac1b4c13c1d3424cb",
            measurementId: "G-PBGX8WR5KT"
        };

        const app = initializeApp(firebaseConfig)
        const messaging = getMessaging(app)
        const subscribeErrorMessageEl = document.querySelector('#subscribe-error-message')

        let gettingFBToken = false

        subscribeButton.addEventListener('click', () => {
            const subscribeIdsInput = document.querySelector('#subscribe-news-ids')
            if (!subscribeIdsInput) return
            if (!subscribeIdsInput.value && subscribeErrorMessageEl) {
                subscribeErrorMessageEl.innerText = 'Для підписки потрібно вибрати хоча б одну категорію'
                subscribeErrorMessageEl.classList.add('custom-multi-select__error_shown')
                return
            }

            if (gettingFBToken) return
            gettingFBToken = true

            getToken(messaging).then((fbToken) => {
                if (fbToken) {
                    
                    const subscribeIds = subscribeIdsInput.value.split(' ')

                    // console.log('fbToken', fbToken)
                    // console.log('subscribeIds', subscribeIds)
                    fetch(API, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                            'X-Requested-With': 'XMLHttpRequest',
                            'X-CSRF-Token': csrfToken
                        },
                        body: JSON.stringify({
                            'push_token': fbToken,
                            'section_id': subscribeIds
                        })
                    }).then(() => {
                        gettingFBToken = false
                        // console.log('token sent to backend')
                        CNS.$fns.closeSubscribeNewsModal()
                        CNS.$fns.openInformModal()
                    }).catch((err) => {
                        gettingFBToken = false
                        // console.log('err', err.data)
                    })

                } else {
                    console.log('No registration token available. Request permission to generate one.');
                    gettingFBToken = false
                }
            }).catch(err => {
                gettingFBToken = false
                const persmissionBlocked = err.message.indexOf('messaging/permission-blocked') != -1
                if (persmissionBlocked) {
                    CNS.$fns.closeSubscribeNewsModal()
                    CNS.$fns.openBlockedNotifyModal()
                }
            })
        })

        onMessage(function (payload) {
            const title = payload.notification.title;
            const options = {
                body: payload.notification.body,
                icon: payload.notification.icon,
            }
            const notification = new Notification(title, options)

            notification.addEventListener('click', function() {
                window.location.href = payload.data.url
            })
        })
    }
})()
